import { useEffect } from 'react'

interface useInitProps {
  showModal: boolean
  setModalLoaded: Function
  confirmAction?: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    props.setModalLoaded(true)
  }, [props.showModal])
}

export default useInit
